var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { transparentize } from 'polished';
import React from 'react';
import { css, mq, styled } from "../../utils";
import { Button } from "../Button";
var MyFooter = styled.footer(function (_a) {
    var colors = _a.theme.colors;
    return mq({
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        height: ['56px', '56px', '100px'],
        display: 'flex',
        justifyContent: ['space-evenly', 'flex-end'],
        alignItems: 'center',
        padding: [0, '0 4.5rem'],
        background: colors.primary,
        zIndex: '1000',
    });
});
var StyledButton = styled(Button)(function (_a) {
    var _b = _a.theme, colors = _b.colors, font = _b.font;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    margin: 0 1rem;\n    padding-right: 1rem;\n    background: transparent;\n    color: ", ";\n    border-color: ", ";\n    text-transform: uppercase;\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: 0.1rem;\n\n    &[disabled] {\n      opacity: 0.4;\n      color: ", ";\n      border: 1px solid ", ";\n\n      ", ";\n    }\n\n    &:not([disabled]) {\n      &:hover {\n        color: ", " !important;\n        border-color: ", " !important;\n        background: ", " !important;\n      }\n    }\n\n    ", ";\n  "], ["\n    margin: 0 1rem;\n    padding-right: 1rem;\n    background: transparent;\n    color: ", ";\n    border-color: ", ";\n    text-transform: uppercase;\n    font-weight: ", ";\n    font-size: ", ";\n    letter-spacing: 0.1rem;\n\n    &[disabled] {\n      opacity: 0.4;\n      color: ", ";\n      border: 1px solid ", ";\n\n      ",
        ";\n    }\n\n    &:not([disabled]) {\n      &:hover {\n        color: ", " !important;\n        border-color: ", " !important;\n        background: ", " !important;\n      }\n    }\n\n    ",
        ";\n  "])), colors.white, colors.white, font.weight.semiBold, font.size.normal, colors.white, colors.white, mq({
        borderWidth: [0, 1],
    }), transparentize(0.1, colors.white), transparentize(0.1, colors.white), transparentize(0.9, colors.black), mq({
        padding: [0, '0 1rem'],
        borderWidth: [0, 1],
        fontSize: ['0.6rem', '0.6rem', '1rem'],
        height: ['38px', '38px', '56px'],
        lineHeight: ['38px', '38px', '56px'],
    }));
});
var GhostButton = styled(StyledButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  border: none !important;\n\n  &:not([disabled]) {\n    &:hover {\n      padding: 1rem;\n    }\n  }\n"], ["\n  border: none !important;\n\n  &:not([disabled]) {\n    &:hover {\n      padding: 1rem;\n    }\n  }\n"])));
var VerticalSep = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 2px;\n  height: 20px;\n  background: #fff;\n\n  ", ";\n"], ["\n  width: 2px;\n  height: 20px;\n  background: #fff;\n\n  ",
    ";\n"])), mq({
    display: ['block', 'none'],
}));
var Footer = function (_a) {
    var onCancel = _a.onCancel, onSubmit = _a.onSubmit, retry = _a.retry, disabled = _a.disabled, labels = _a.labels;
    return (React.createElement(MyFooter, null,
        React.createElement(GhostButton, { type: "button", ghost: true, onClick: onCancel }, labels.cancel),
        React.createElement(VerticalSep, null),
        React.createElement(StyledButton, { type: "button", outline: true, onClick: retry }, labels.again),
        React.createElement(VerticalSep, null),
        React.createElement(StyledButton, { type: "button", disabled: disabled, outline: true, onClick: !disabled ? onSubmit : undefined }, labels.save)));
};
export default Footer;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=Footer.js.map